import type { CSSProperties } from 'react';

/** Icon dùng lại giữa các màn trong luồng học. */
export const SpeakerIcon = ({ size = 20, color = '#fff' }: { size?: number; color?: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 5 6 9H2v6h4l5 4z" />
    <path d="M15.5 8.5a5 5 0 0 1 0 7" />
    <path d="M19 5a9 9 0 0 1 0 14" />
  </svg>
);

export const CheckIcon = ({ c = '#fff', size = 16 }: { c?: string; size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={3} strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 6 9 17l-5-5" />
  </svg>
);

export const CrossIcon = ({ c = '#fff', size = 15 }: { c?: string; size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={3} strokeLinecap="round">
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
);

/** Huy hiệu đúng/sai ở góc một thẻ đáp án. */
export const answerBadge = (c: string): CSSProperties => ({
  position: 'absolute',
  top: 8,
  right: 8,
  width: 22,
  height: 22,
  borderRadius: '50%',
  background: c,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

/** Nút chính ở cuối màn học. */
export const primaryBtn: CSSProperties = {
  width: '100%',
  height: 52,
  borderRadius: 'var(--radius-control)',
  background: 'var(--cta-default)',
  color: '#fff',
  border: 'none',
  cursor: 'pointer',
  fontFamily: 'var(--font-vi)',
  fontWeight: 600,
  fontSize: 16,
};

/** Khung ngoài cùng của mọi màn trong luồng học. */
export const screenShell: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  fontFamily: 'var(--font-vi)',
  background: 'var(--surface-page)',
};
